import { CovalentBalanceItem } from '@shared/types/frontend';
import { BiSortAlt2 } from 'react-icons/bi';
import { IoIosArrowDown } from 'react-icons/io';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useSession } from '@/contexts/LitSessionProvider';
import Image from 'next/image';
interface SelectedFromAssetsDetailsProps {
  toggleOrderModal: () => void;
  totalAmount: string;
  fromAssets: CovalentBalanceItem[];
  isSwitched: boolean;
  setIsSwitched: (value: boolean) => void;
}
const initialAssetValues = {
  amountToUseStr: null,
  quote_rate: null,
  contract_ticker_symbol: null,
  usd_value: null
};
const SelectedFromAssetsDetails = ({
  totalAmount,
  fromAssets,
  isSwitched,
  setIsSwitched,
  toggleOrderModal
}: SelectedFromAssetsDetailsProps) => {
  const {
    PKP
  } = useSession();
  const sanitizedTotalAmount = totalAmount?.replace(/,/g, '') || '0';
  const displayAmount = isSwitched ? sanitizedTotalAmount : sanitizedTotalAmount;
  const {
    data: userBalance
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress],
    useGeniusAPI: true
  });
  const firstAsset = fromAssets?.[0] || initialAssetValues;
  const displayCurrency = isSwitched && fromAssets.length === 1 ? firstAsset.contract_ticker_symbol || 'USD' : 'USD';
  const convertion = !isSwitched ? Number(firstAsset?.amountToUseStr || 0) / Number(firstAsset?.quote_rate || 1) : Number(firstAsset?.amountToUseStr || 0);
  return <div className='flex flex-col justify-center items-center mt-2 w-full' data-sentry-component="SelectedFromAssetsDetails" data-sentry-source-file="SelectedFromAssetsDetails.tsx">
     
      <div className='w-full mt-2'>
        <div className='m-auto text-5xl md:text-7xl text-genius-cream break-all w-full'>
          <div className={`relative swapHeader w-full ${!fromAssets[0] && 'opacity-50'}`}>
            <div className={`absolute top-[15px] w-full justify-center items-center transition-all`}>
              <div className='w-full flex justify-center relative ta-c space-x-2'>
                {/* <div
                  onClick={toggleOrderModal}
                  className='h-[28px] bg-genius-indigo text-genius-cream/50 cursor-pointer border-genius-blue border-[1px] rounded-full text-xs flex items-center ta-c px-2 w-fit'
                 >
                  One Time Order <IoIosArrowDown className='w-[16px] ml-2' />
                 </div> */}
                <div className='h-[26px]'>
                  <Image src='/static/genius-dark-logo.png' alt='Genius Logo' className='pr-2 pb-1' width={100} height={50} data-sentry-element="Image" data-sentry-source-file="SelectedFromAssetsDetails.tsx" />
                  </div>
              </div>
              <div className='justify-center ta-c relative'>
                <p className={`items-center justfify-center mx-auto text-center mt-6 ${!fromAssets || fromAssets.length === 0 ? 'text-[60px]' : Number(displayAmount) > 10000 ? 'text-[22px] mt-[40px]' : Number(displayAmount) > 1000 ? 'text-[36px] mt-8' : ''}`}>
                  {fromAssets && fromAssets.length > 0 ? isSwitched ? Number(displayAmount).toLocaleString(undefined, {
                  maximumFractionDigits: 3
                }) : Number(displayAmount) === 0 ? '0' : Number(displayAmount).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                }) : '0'}
                  <span className='text-genius-cream/70 ml-2 inline-flex'>
                    {displayCurrency}
                    <div onClick={() => setIsSwitched(!isSwitched)} className={`rounded-full  w-[25px] h-[25px] ml-4 flex items-center bg-genius-blue ta-c justify-center
                        ${!fromAssets || fromAssets.length === 0 ? 'mt-[16px]' : Number(displayAmount) > 10000 ? 'mt-[-2px]' : Number(displayAmount) > 1000 ? 'mt-[5px]' : 'mt-[10px]'}
                      `}>
                      <BiSortAlt2 className='text-primary' size={12} data-sentry-element="BiSortAlt2" data-sentry-source-file="SelectedFromAssetsDetails.tsx" />
                    </div>
                  </span>
                </p>
              </div>
            </div>

            <div className='absolute top-[140px] w-full'>
              {fromAssets?.[0] && <div className='flex flex-nowrap justify-center items-center gap-2 text-xs cursor-pointer'>
                  {!isSwitched ? `${convertion?.toFixed(3)} ${firstAsset?.contract_ticker_symbol || ''}` : `${convertion?.toFixed(2)} USD`}
                </div>}

              <div className='mb-4 flex justify-center mt-4 text-genius-cream/50 items-center text-xs'>
                <div>
                  {fromAssets?.[0] && <>
                      {firstAsset?.usd_value !== undefined && !isNaN(Number(firstAsset?.usd_value)) ? `$${Number(firstAsset?.usd_value)?.toFixed(2)} of ${firstAsset?.contract_ticker_symbol + ' available' || 'N/A'}` : '0 of 0'}
                    </>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default SelectedFromAssetsDetails;